import React from "react";
import { buscarGRU, infoGRU } from "../../actions/GRUActions";
import {
  View,
  FieldsGroup,
  FieldDetail,
  ActionButton,
  Card,
  LinkAction
} from "react-template";
export default class GRUHome extends View {
  constructor(props) {
    super(props);
    this.state = {
      formulario: {},
      schema: {},
      status: "",
      boletosGerados: 0,
      qtdeBoletosPagos: 0,
      valorTotal: 0,
      activeLoader: true
    };
  }

  componentWillMount() {
    this.loadForm(this.props.params.id);
  }

  loadForm(formID) {
    buscarGRU(
      formID,
      res => {
        const formulario = res.data;
        const schema = JSON.parse(formulario.formSchema).schema;

        // Define o modelo que texto do status na tela
        const statusTitulo = formulario.status
          ? "Diponível para o público"
          : "Indiponível para o público";
        const statusCor = formulario.status ? " green" : " red";
        const status = formulario.status;

        this.setState({
          ...this.state,
          formulario: formulario,
          schema: schema,
          status: status,
          statusTitulo: statusTitulo,
          statusCor: statusCor
        });
      },
      error => {
        this.notifyError("Erro ao carregar  GRU", "");
      }
    );

    infoGRU(
      formID,
      res => {
        const { boletosGerados, qtdeBoletosPagos, valorTotal } = res.data;

        this.setState({
          ...this.state,
          boletosGerados,
          qtdeBoletosPagos,
          valorTotal,
          activeLoader: false
        });
      },
      error => {
        this.setState({ activeLoader: false });
        this.notifyError("Erro ao carregar  GRU", "");
      }
    );
  }

  getStatus() {
    return (
      <LinkAction
        icone={this.state.status ? "done" : "clear"}
        type="icon"
        tooltip={this.state.statusTitulo}
        color={this.state.statusCor}
      />
    );
  }

  render() {
    return (
      <Card
        titulo={this.state.schema.title}
        descricao={this.state.schema.description}
        tools={this.getStatus()}
        displayLoading={this.state.activeLoader}
        loadingPosition="top"
      >
        <FieldsGroup>
          <FieldDetail
            width={3}
            titulo="Boletos Gerados"
            content={`${this.state.boletosGerados} `}
          />
          <FieldDetail
            width={3}
            titulo="Total Recebido"
            content={`R$ ${this.state.valorTotal}`}
          />
        </FieldsGroup>
        <ActionButton
          label="Editar"
          icon="edit"
          to={`/admin/gru/${this.props.params.id}/editar`}
        />
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/gru/list/tabs/GRUHome.js